import { useRequestPayment } from "@/entities/payment";
import { Button } from "@/shared/ui/button";
import { Spinner } from "@/shared/ui/spinner";

interface PayoutButtonProps {
  wallet: string;
  amount: string;
  onClose: () => void;
}

export const PayoutButton = ({
  wallet,
  amount,
  onClose,
}: PayoutButtonProps) => {
  const { mutateAsync, isPending } = useRequestPayment();

  const handleClick = () => {
    mutateAsync({
      wallet,
      amount: Number(amount),
    }).then(onClose);
  };

  return (
    <Button
      type="button"
      onClick={handleClick}
      disabled={!wallet || !amount || isPending || wallet.includes(" ")}
    >
      {isPending ? <Spinner /> : "Оставить заявку"}
    </Button>
  );
};
